export const isAccessTokenPresent = () => {
  const authToken = window.localStorage.getItem('auth')
  return authToken && JSON.parse(authToken).access_token
}
